import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Gift, Receipt, TrendingUp, Menu, X, Plus, User } from 'lucide-react';
const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsHovering(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isMobile) {
      setIsHovering(false);
    }
  };
  const menuItems = [{
    icon: LayoutDashboard,
    label: 'Panoramica',
    path: '/overview',
    active: location.pathname === '/overview' || location.pathname === '/'
  }, {
    icon: Gift,
    label: 'Premi',
    path: '/rewards',
    active: location.pathname.startsWith('/rewards')
  }, {
    icon: Receipt,
    label: 'Riscatti e Utilizzi',
    path: '/claims',
    active: location.pathname.startsWith('/claims')
  }, {
    icon: TrendingUp,
    label: 'Insight',
    path: '/insights',
    active: location.pathname === '/insights'
  }];
  const quickActions = [{
    icon: Plus,
    label: 'Crea Premio',
    onClick: () => navigate('/rewards/new')
  }, {
    icon: User,
    label: 'Modifica Profilo',
    onClick: () => navigate('/profile')
  }];
  const isExpanded = isMobile ? !collapsed : isHovering;
  return <aside className={`text-white flex flex-col fixed h-full z-40 transition-all duration-150 ${isExpanded ? 'w-64' : 'w-20'} lg:relative bg-greenback`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{
    position: 'absolute'
  }} data-id="element-626">
      <button className="lg:hidden absolute right-4 top-4 text-white" onClick={toggleSidebar} data-id="element-627">
        {collapsed ? <Menu size={20} data-id="element-628" /> : <X size={20} data-id="element-629" />}
      </button>

      {/* Logo Area - Fixed Height */}
      <div className="flex items-center h-[88px] border-b border-white/20 overflow-hidden" data-id="element-630">
        <div className="w-20 flex justify-center flex-shrink-0" data-id="element-631">
          <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback logo" className="h-10 w-10 brightness-0 invert transition-all duration-150" data-id="element-632" />
        </div>
        <div className={`transition-all duration-150 ${isExpanded ? 'opacity-100 max-w-full' : 'opacity-0 max-w-0 overflow-hidden'}`} data-id="element-633">
          <h2 className="text-xl text-white whitespace-nowrap" data-id="element-634">Greenback</h2>
          <p className="text-sm text-white whitespace-nowrap" data-id="element-635">
            Partner platform
          </p>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="py-6" data-id="element-636">
        <ul className="space-y-1 px-0" data-id="element-637">
          {menuItems.map((item, index) => <li key={index} data-id="element-638">
              <Link to={item.path} className={`flex items-center py-3 rounded-lg transition-colors mx-3 ${item.active ? `bg-white text-greenback` : 'text-white hover:bg-white/10'}`} data-id="element-639">
                <div className="w-14 flex items-center justify-center flex-shrink-0" data-id="element-640">
                  <item.icon className="h-5 w-5" data-id="element-641" />
                </div>
                <span className={`font-medium whitespace-nowrap transition-all duration-150 ${isExpanded ? 'opacity-100 max-w-full' : 'opacity-0 max-w-0 overflow-hidden'}`} data-id="element-642">
                  {item.label}
                </span>
              </Link>
            </li>)}
        </ul>
      </nav>

      {/* Quick Actions - Fixed Height */}
      <div className="border-t border-white/20 overflow-hidden" data-id="element-643">
        <div className={`px-3 h-[32px] flex items-center transition-all duration-150 ${isExpanded ? 'opacity-100' : 'opacity-0'}`} data-id="element-644">
          <p className="text-xs font-semibold text-white/60 uppercase tracking-wider whitespace-nowrap" data-id="element-645">
            Azioni Rapide
          </p>
        </div>
        <ul className="space-y-1 px-0" data-id="element-646">
          {quickActions.map((action, index) => <li key={index} data-id="element-647">
              <button onClick={action.onClick} className="w-full flex items-center h-[52px] rounded-lg transition-colors mx-3 text-white hover:bg-white/10" data-id="element-648">
                <div className="w-14 flex items-center justify-center flex-shrink-0" data-id="element-649">
                  <action.icon className="h-5 w-5" data-id="element-650" />
                </div>
                <span className={`font-medium whitespace-nowrap transition-all duration-150 ${isExpanded ? 'opacity-100 max-w-full' : 'opacity-0 max-w-0 overflow-hidden'}`} data-id="element-651">
                  {action.label}
                </span>
              </button>
            </li>)}
        </ul>
      </div>

      {/* Footer Version - Fixed Height */}
      <div className="mt-auto border-t border-white/20" data-id="element-652">
        <div className="flex items-center h-[72px] overflow-hidden" data-id="element-653">
          <div className="w-20 flex justify-center flex-shrink-0" data-id="element-654">
            <span className="text-xs text-white" data-id="element-655">v1.0</span>
          </div>
          <div className={`text-xs text-white transition-all duration-150 ${isExpanded ? 'opacity-100 max-w-full' : 'opacity-0 max-w-0 overflow-hidden'}`} data-id="element-656">
            <p className="whitespace-nowrap" data-id="element-657">© 2026 Greenback</p>
            <p className="whitespace-nowrap" data-id="element-658">Versione 1.0.0</p>
          </div>
        </div>
      </div>
    </aside>;
};
export default Sidebar;